import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DbService } from 'src/app/services/db-service/db.service';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { filter } from 'rxjs/operators';

import { PipeTransform, Pipe } from '@angular/core';
import { BusinessServiceService } from '../../micro-apps/business/services/business-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
import { CreateNewBusinessComponent } from '../../micro-apps/business/create-new-business/create-new-business.component';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';
import { SocialLoginService } from '../../micro-apps/website-marketing/services/social-login-service.service';
import { StaffServiceService } from '../../micro-apps/staff/service/staff-service.service';
import { AppRegistryServiceService } from '../../micro-apps/app-registry/services/app-registry-service.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { NavMenuService } from 'src/app/services/navservice/navmenu.service';
import { Subscription } from 'rxjs';
import { MastersService } from '../../master/screens/master.service';
import { IframRedirectionsService } from 'src/app/services/ifram-redirections.service';
import { AiWriterWrapperComponent } from '../../micro-apps/ai-writer-wrapper/ai-writer-wrapper.component';
import { WebsiteMarketingServiceService } from '../../micro-apps/website-marketing/services/website-marketing-service.service';

declare const bootstrap: any;
interface SideNavGroup {
  category: string;
  apps: any[];
}

@Pipe({
  name: 'limitToPipe',
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number): string {
    let trail = '...';

    return value?.length > limit ? value.substring(0, limit) + trail : value;
  }
}

@Pipe({
  name: 'sidebarSearch',
  pure: false,
})
export class SidebarSearchPipe implements PipeTransform {
  transform(items: any[], query: string): any[] {
    if (!items) return [];
    if (!query || query.trim() === '') return items;
    const q = query.trim().toLowerCase();
    return items.filter((item: any) => {
      const name = (item.displayName || item.appName || '').toLowerCase();
      return name.includes(q);
    });
  }
}

@Component({
  selector: 'app-sidenav-admin',
  templateUrl: './sidenav-admin.component.html',
  styleUrls: [
    './sidenav-admin.component.scss',
    './mq-sidenav-admin.component.scss',
  ],
})
export class SidenavAdminComponent implements OnInit, OnDestroy {
  // Add these properties
  currentMoreMenuItems: any[] = [];
  currentParentItem: any;

  @Output() openSecondPanel = new EventEmitter<any>();
  @Output() collapsingMainNav = new EventEmitter<any>();
  @Output() openThirdPanel = new EventEmitter<any>();
  @Output() getDetails = new EventEmitter<any>();
  @Output() subPanelOpened = new EventEmitter<boolean>();
  @Output() changeTab = new EventEmitter<{
    tab: string;
    data?: any;
    feature?: string;
  }>();
  selectedProjectId: any = '';
  features: any;
  groupedSideNav: SideNavGroup[] = [];
  pinnedApps: any[] = [];
  sidebarSearchQuery: string = '';

  constructor(
    private router: Router,
    private _dbStorage: DbService,
    private _businessService: BusinessServiceService,
    private _snackBar: MatSnackBar,
    private _eventService: EventEmmiterService,
    private websiteMarketingService: WebsiteMarketingServiceService,
    private socialLogin: SocialLoginService,
    private staffService: StaffServiceService,
    private appRegistryService: AppRegistryServiceService,
    private subscriptionService: SubscriptionService,
    private navMenuService: NavMenuService,
    private masterService: MastersService,
    private iframService: IframRedirectionsService,
    private _authService: AuthServiceService
  ) {
    this.getScreenSize();
    this.gettingAllbusiness();
    this.checkingSwitchBusiness();
    this.checkCurrentPanel();
    this._eventService.updateBusinessName.subscribe((res: any) => {
      if (res.update) {
        let bDetails = window.localStorage.getItem('bDetails') || '';
        if (bDetails) {
          this.bDetails = JSON.parse(bDetails);
          this.businessName = this.bDetails.name;
        } else {
          this.businessName = 'Simpo';
        }
      }
    });
    this.bDetails = window.localStorage.getItem('bDetails');
    if (this.bDetails) {
      this.bDetails = JSON.parse(this.bDetails);
      this.businessId = this.bDetails.id;
    }
    this.loadFeatures();
    this.checkPassbookInstall();
  }

  checkPassbookInstall() {
    this.navMenuService.isAppInstalled("Passbook", this.businessId).subscribe({
      next: (res: any) => {
        if (res.data) {
          const voucherData = {
            subAppName: 'Passbook Vouchers',
            displayName: 'Vouchers',
            redirectionUrl: '/admin/vouchers/passbook-vouchers',
            show: true,
          }
          this.defaultApps.forEach((element: any) => {
            if (element.appName == 'Coupons') {
              element.subAppName.push(voucherData);
            }
          });
        }
      }
    })
  }
  businessId: any;

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    setTimeout(() => {
      let currentUrl = window.location.href.split('/');
      let redirectingUrl = this.router.url.split('//')[0];
      this.checkCurrentPanel();
      //
      this.sideNavData.forEach((data) => {
        if (data.name && currentUrl.includes(data.name.toLowerCase())) {
          data.status = true;
          if (data.subArray.length > 0) {
            data.subArray.forEach((element) => {
              if (element.redirectingUrl) {
                if (element.redirectingUrl === redirectingUrl) {
                  element.status = true;
                } else {
                  element.status = false;
                }
              }
            });
          }
        } else {
          data.status = false;
          data.subArray.forEach((element) => {
            if (element.redirectingUrl) {
              if (element.redirectingUrl === redirectingUrl) {
                element.status = true;
              } else {
                element.status = false;
              }
            } else {
              if (element.thirdPanelData) {
                element.thirdPanelData.forEach((thirdPanel) => {
                  if (thirdPanel.redirectingUrl != redirectingUrl) {
                    thirdPanel.status = false;
                    this.openThirdPanel.emit({
                      value: false,
                      data: element.thirdPanelData,
                    });
                  }
                });
              }
              // }
            }
          });
        }
      });
    }, 500);
  }
  checkingSwitchBusiness() {
    this._eventService.switchBusiness.subscribe((res: any) => {
      if (res.switchBusiness) {
        this.gettingAllbusiness();
        let bDetails = window.localStorage.getItem('bDetails') || '';
        if (bDetails) {
          this.bDetails = JSON.parse(bDetails);
          this.businessName = this.bDetails.name;
          this.businessType = this.bDetails?.type || 'STATIC';
          this.loadNavData();
          // this.checkforCurrentUrl();
        } else {
          this.businessName = 'Simpo';
        }
      }
    });
  }

  loadFeatures() {
    this.masterService.getFeaturesForBusiness(this.businessId).subscribe({
      next: (res: any) => {
        this.features = res;
        localStorage.setItem(
          `crm_features_${this.businessId}`,
          JSON.stringify(this.features),
        );
      },
      error: (err) => {
        console.error('Error loading features', err);
      },
    });
  }

  screenWidth: any;
  businessName: any;
  bDetails: any;
  businessType: 'STATIC' | 'E_COMMERCE' = 'STATIC';
  allBusiness: any = [];
  // @HostListener("window: resize", ["$event"])
  getScreenSize() {
    this.screenWidth = window.innerWidth;
    // this.businessName = JSON.parse(window.localStorage.getItem('bDetails') | null)
  }

  ngOnDestroy() {
    if (this.settings) {
      this.settings.unsubscribe();
    }
    if (this.blogs) {
      this.blogs.unsubscribe();
    }
    if (this.leads) {
      this.leads.unsubscribe();
    }
    if (this.invoices) {
      this.invoices.unsubscribe();
    }
    if (this.navigationSubscription) this.navigationSubscription?.unsubscribe();
  }

  gettingAllbusiness() {
    this.allBusiness = window.localStorage.getItem('business');
    this.allBusiness = JSON.parse(this.allBusiness);
    if (this.allBusiness?.length > 0) {
      this.allBusiness.forEach((element) => {
        if (element.id === this._dbStorage.getBusinessId()) {
          element.status = true;
        } else {
          element.status = false;
        }
      });
    }
  }

  secondPanel: boolean = false;
  collapseSideNav: boolean = false;
  showSidePanel: any;

  sideNavData: any = [];

  logo: any = {
    Website: './../../../../assets/images/sidepanel/website.svg',
    activeWebsite: './../../../../assets/images/sidepanel/website_active.svg',
    // 'Sales': './../../../../assets/images/sidepanel/purchases.svg',
    Sales: './../../../../assets/images/sidepanel/invoices.svg',
    activeSales: './../../../../assets/images/sidepanel/purchases_active.svg',
    Purchases: './../../../../assets/images/sidepanel/purchases.svg',
    activePurchases:
      './../../../../assets/images/sidepanel/purchases_active.svg',
    Quotations: './../../../../assets/images/sidepanel/quatations.svg',
    activeQuotations:
      './../../../../assets/images/sidepanel/purchases_active.svg',
    Expenses: './../../../../assets/images/sidepanel/purchases.svg',
    activeExpenses:
      './../../../../assets/images/sidepanel/purchases_active.svg',
    CRM: './../../../../assets/images/sidepanel/crm.svg',
    activeCRM: './../../../../assets/images/sidepanel/crm_active.svg',
    Appointment: './../../../../assets/images/sidepanel/appointment.svg',
    activeAppointment:
      './../../../../assets/images/sidepanel/appointment_active.svg',
    SMM: './../../../../assets/images/sidepanel/smm.svg',
    activeSMM: './../../../../assets/images/sidepanel/marketing_active.svg',
    'Social Flow': './../../../../assets/images/sidepanel/smm.svg',
    Prism: './../../../../assets/images/sidepanel/prism.svg',
    User: './../../../../assets/images/sidepanel/staff.svg',
    activeUser: './../../../../assets/images/sidepanel/staff_active.svg',
    'AI Writer': './../../../../assets/images/sidepanel/ai_writer.svg',
    Apps: './../../../../assets/images/sidepanel/apps.svg',
    activeApps: './../../../../assets/images/sidepanel/apps_active.svg',
    Products: './../../../../assets/images/sidepanel/products.svg',
    activeProducts: './../../../../assets/images/sidepanel/products_active.svg',
    Customers: './../../../../assets/images/sidepanel/customers.svg',
    activeCustomers:
      './../../../../assets/images/sidepanel/customers_active.svg',
    Vendors: './../../../../assets/images/sidepanel/customers.svg',
    activeVendors: './../../../../assets/images/sidepanel/customers_active.svg',
    'Billing Customers': './../../../../assets/images/sidepanel/customers.svg',
    'activeBilling Customers':
      './../../../../assets/images/sidepanel/customers_active.svg',
    Orders: './../../../../assets/images/sidepanel/orders.svg',
    activeOrders: './../../../../assets/images/sidepanel/orders_active.svg',
    Discounts: './../../../../assets/images/sidepanel/discounts.svg',
    activeDiscounts:
      './../../../../assets/images/sidepanel/discounts_active.svg',
    Dashboard: './../../../../assets/images/sidepanel/dashboard.svg',
    DASHBOARD: './../../../../assets/images/sidepanel/dashboard.svg',
    activeDashboard:
      './../../../../assets/images/sidepanel/dashboard_active.svg',
    Home: './../../../../assets/images/sidepanel/home.svg',
    activeHome: './../../../../assets/images/sidepanel/home_active.svg',
    SEO: './../../../../assets/images/sidepanel/SEO.svg',
    Preview: './../../../../assets/images/sidepanel/preview.svg',
    Settings: './../../../../assets/images/sidepanel/settings.svg',
    SETTING: './../../../../assets/images/sidepanel/settings.svg',
    Themes: './../../../../assets/images/sidepanel/themes.svg',
    Analytics: './../../../../assets/images/sidepanel/analytics.svg',
    'CRM Dashboard': './../../../../assets/images/sidepanel/crm_dashboard.svg',
    SalesDashboard: './../../../../assets/images/sidepanel/crm_dashboard.svg',
    Leads: './../../../../assets/images/sidepanel/leads.svg',
    'My Leads': './../../../../assets/images/sidepanel/myleads.svg',
    Prospects: './../../../../assets/images/sidepanel/prospects.svg',
    Tasks: './../../../../assets/images/sidepanel/tasks.svg',
    Calls: './../../../../assets/images/sidepanel/calls.svg',
    Meetings: './../../../../assets/images/sidepanel/meetings.svg',
    'CRM Customers': './../../../../assets/images/sidepanel/crm_customers.svg',
    'CRM Setting': './../../../../assets/images/sidepanel/crm_settings.svg',
    'Indirect Income':
      './../../../../assets/images/sidepanel/indirect_income.svg',
    Service: './../../../../assets/images/sidepanel/manage_appiontment.svg',
    Staff: './../../../../assets/images/sidepanel/staff.svg',
    Appointments: './../../../../assets/images/sidepanel/appointments.svg',
    'Purchase Orders':
      './../../../../assets/images/sidepanel/purchase_orders.svg',
    'Debit Notes': './../../../../assets/images/sidepanel/debit_notes.svg',
    'Delivery Challans':
      './../../../../assets/images/sidepanel/delivery_challans.svg',
    Ideas: './../../../../assets/images/sidepanel/ideas.svg',
    Post: './../../../../assets/images/sidepanel/post.svg',
    'Post Summary': './../../../../assets/images/sidepanel/post_summary.svg',
    Calender: './../../../../assets/images/sidepanel/calendar.svg',
    Invoices: './../../../../assets/images/sidepanel/invoices.svg',
    'Credit Notes': './../../../../assets/images/sidepanel/credit_notes.svg',
    Blogs: './../../../../assets/images/sidepanel/blogs.svg',
    activeBlogs: './../../../../assets/images/sidepanel/activeBlogs(2).svg',
    'Metal Price History': './../../../../assets/images/sidepanel/website.svg',
    'activeMetal Price History':
      './../../../../assets/images/sidepanel/website_active.svg',
    Helpdesk: './../../../../assets/images/sidepanel/helpdesk.svg',
    Tickets: './../../../../assets/images/sidepanel/tickets.svg',
    TICKET: './../../../../assets/images/sidepanel/tickets.svg',
    'My Tickets': './../../../../assets/images/sidepanel/my_tickets.svg',
    MY_TICKET: './../../../../assets/images/sidepanel/my_tickets.svg',
    'Staff Tickets': './../../../../assets/images/sidepanel/staff_tickets.svg',
    STAFF_TICKET: './../../../../assets/images/sidepanel/staff_tickets.svg',
    'Customer Ratings':
      './../../../../assets/images/sidepanel/customer_ratings.svg',
    CUSTOMER_RATING:
      './../../../../assets/images/sidepanel/customer_ratings.svg',
    'Scheme Enrollments':
      './../../../../assets/images/sidepanel/scheme_enrollment.svg',
    Redemptions: './../../../../assets/images/sidepanel/redemptions.svg',
    'Due Payments': './../../../../assets/images/sidepanel/due_payments.svg',
    Transactions: './../../../../assets/images/sidepanel/transaction.svg',
    'Gold Prices': './../../../../assets/images/sidepanel/gold_history.svg',
    'passbook-config': './../../../../assets/images/sidepanel/crm_settings.svg',
    Planboard: './../../../../assets/images/sidepanel/Planboard.svg',
    // "activePlanboard": './../../../../assets/images/sidepanel/Planboard.svg',
    'Store Listing': '../../../../assets/images/sidepanel/store-list-icon.svg',
    activeStoreListing:
      '../../../../assets/images/sidepanel/store-list-icon.svg',
    storeList: '../../../../assets/images/sidepanel/store-list-icon.svg',
    Newsletter: '../../../assets/images/sidepanel/newsletter_lisitng.svg',
    subscribers: '../../../assets/images/sidepanel/newsletter_lisitng.svg',
    // Inbox: '../../../assets/images/sidepanel/inbox.svg',
    Projects: '../../../assets/images/sidepanel/project.svg',
    Views: '../../../assets/images/sidepanel/views.svg',
    'Your Work': '../../../assets/images/sidepanel/your_work.svg',
    Archives: '../../../assets/images/sidepanel/archive_svg.svg',
    'Home Appointments':
      './../../../../assets/images/sidepanel/appointments.svg',
    Segmentation: './../../../../assets/images/sidepanel/segmentations.svg',
    PassBook: './../../../../assets/images/sidepanel/passbook.svg',
    activePassBook: './../../../../assets/images/sidepanel/passbook_active.svg',
    Catalogue: './../../../../assets/images/sidepanel/catalogue.svg',
    'People Manager':
      './../../../../assets/images/sidepanel/people_manager.svg',
    Scans: './../../../../assets/images/sidepanel/scans.svg',
    Templates: './../../../../assets/images/sidepanel/list-templates.svg',
    Campaigns: './../../../../assets/images/sidepanel/marketing.svg',
    Campaign: './../../../../assets/images/sidepanel/campaings.svg',
    'AI Composer': './../../../../assets/images/sidepanel/ai-composer.svg',
    'Project Lens': './../../../../assets/images/sidepanel/project-lens.svg',
    'Prospect IQ': './../../../../assets/images/sidepanel/prospect-iq.svg',
    Materials: './../../../../assets/images/sidepanel/materials.svg',
    'Material Type': './../../../../assets/images/sidepanel/materials.svg',
    'Ads Manager': './../../../../assets/images/sidepanel/orders.svg',
    Inbox: './../../../../assets/images/sidepanel/post.svg',
    'Overview': './../../../../assets/images/sidepanel/analytics.svg',
    'All Messages': './../../../../assets/images/sidepanel/post.svg',
    'Comments': './../../../../assets/images/sidepanel/ideas.svg',
    'Mentions': './../../../../assets/images/sidepanel/notification.svg',
    'Sales Tracking': './../../../../assets/images/sidepanel/invoices.svg',
    'Abandoned Carts': './../../../../assets/images/sidepanel/cart.svg',
    'Product Views': './../../../../assets/images/sidepanel/eye.svg',
    'Search History': './../../../../assets/images/sidepanel/search.svg',
    'Navigator': './../../../../assets/images/sidepanel/chatbot.svg',
    'Refer and Earn': './../../../../assets/images/sidepanel/refer_earn.svg',
    'Coupons': './../../../../assets/images/sidepanel/coupons.svg',
    'Forms': './../../../../assets/images/sidepanel/form.svg',
    Menu: './../../../../assets/images/sidepanel/crm_dashboard.svg',
    Horizyn: './../../../../assets/images/sidepanel/horizyn.svg',
    Workflows: './../../../../assets/images/sidepanel/work_flows.svg',
    Recommendations: './../../../../assets/images/sidepanel/recommendations.svg'
  };

  userType = window.localStorage.getItem('type');
  viewAccess: boolean = true;
  isStaffAdmin: boolean = true;

  get hasAppPermission(): boolean {
    return this.staffService.getStaffPermission('APP', 'VIEW');
  }
  subIndustryName: string = '';
  removeHome: boolean = false;
  ngOnInit(): void {
    this.forclicked();
    this.backRedirectionChecks();
    this.viewAccess = this.staffService.getStaffPermission(
      'BUSINESS_ACCOUNT',
      'VIEW',
    );

    let bDetails = window.localStorage.getItem('bDetails') || '';
    if (bDetails) {
      this.bDetails = JSON.parse(bDetails);
      this.businessType = this.bDetails?.type || 'STATIC';
      this.businessName = this.bDetails.name;
      this.subIndustryName = this.bDetails?.subIndustryName || '';
      this.removeHome = this.bDetails?.configs?.removeHome || false;
    } else {
      this.businessName = 'Simpo';
    }
    this.isStaffAdmin = this.staffService.isStaffAdmin();
    this.showSidePanel = this.staffService.showSidePanel();

    this.loadNavData();
    this.updateSidePanel();
    this.checkCurrentPanel();

    // this.sideNavData.forEach((sideNav: any) => {
    //   let isThere = false;

    //   if (sideNav.subArray?.length > 0) {
    //     sideNav.subArray.forEach((child: any) => {
    //       if (this.router.url.includes(child.redirectingUrl)) {
    //         isThere = true;
    //         child.status = true;
    //       } else {
    //         child.status = false;
    //       }

    //       // Check for thirdPanelData in child
    //       if (child.thirdPanelData?.length > 0) {
    //         let isThirdPanelActive = false;
    //         child.thirdPanelData.forEach((thirdPanel: any) => {
    //           if (this.router.url.includes(thirdPanel.redirectingUrl)) {
    //             thirdPanel.status = true;
    //             isThirdPanelActive = true;
    //             isThere = true; // Mark the parent as active
    //             this.openThirdPanel.emit({ value: true, data: child.thirdPanelData });
    //           } else {
    //             thirdPanel.status = false;
    //           }
    //         });
    //         child.status = isThirdPanelActive; // Update child status based on third panel
    //       }
    //     });
    //   } else if (this.router.url.includes(sideNav.redirectingUrl)) {
    //     isThere = true;
    //   }

    //   sideNav.status = isThere;
    // });

    // this.checkforCurrentUrl();

    this.fromHome();
    this.forBlogs();
    this.forLeads();
    this.forInvocies();
    this.trackNavigationChanges();
  }

  private navigationSubscription: any = Subscription;
  trackNavigationChanges() {
    this.navigationSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.checkCurrentPanel();
      });
  }

  isLoading: boolean = false;
  loadNavData(): void {
    this.isLoading = true;
    // Refresh on every load so switching business picks up new permissions immediately
    this.isStaffAdmin = this.staffService.isStaffAdmin();
    this.showSidePanel = this.staffService.showSidePanel();
    this.navMenuService.getNavData(this.businessType).subscribe(
      (navItems: any) => {
        this.sideNavData = [];
        // to check if ideas are enabled 
        navItems.data.filter((app: any) => {
          if (app.appName === 'Social Flow') {
            let ideasEnabled = false;
            let campaignsEnabled = false;
            (app.subAppName || []).forEach((subApp: any) => {
              const name = (subApp?.subAppName || subApp?.displayName || '').toString().toLowerCase();
              if (name === 'ideas') {
                ideasEnabled = true;
              }
              if (name === 'campaigns' || name === 'campaign') {
                campaignsEnabled = true;
              }
            });
            localStorage.setItem('ideas', ideasEnabled ? 'true' : 'false');
            localStorage.setItem('campaigns', campaignsEnabled ? 'true' : 'false');
          }
        })
        this.reFiltersideNavDataDynamically(navItems.data);
        this.isLoading = false;
      },
      (err) => {
        this.sideNavData = [...this.defaultApps];

        this.isLoading = false;
      },
    );
  }

  backRedirectionChecks() {
    let name = 'crm';
    let ev = {
      name: 'Leads',
      status: true,
      redirectingUrl: '/admin/crm/list-leads',
    };
    this._eventService.backbuttonClicked.subscribe((res: any) => {
      if (res.status) {
        setTimeout(() => {
          this.subDataClick(name, ev);
        }, 500);
      }
    });
  }
  reFiltersideNavData() {
    if (!this.businessType || this.businessType == 'STATIC') {
      this.sideNavData = [
        {
          name: 'Home',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/home',
          subArray: [],
          show: true,
        },
        {
          name: 'Website',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          show:
            this.staffService.getStaffPermission('WEBSITE') ||
            this.staffService.getStaffPermission('BLOGS') ||
            this.staffService.getStaffPermission('SEO') ||
            this.staffService.getStaffPermission('WEBSITE_ANALYTICS'),
          subArray: [
            {
              name: 'Preview',
              status: true,
              redirectingUrl: '/admin/website/preview',
              show: this.staffService.getStaffPermission('WEBSITE'),
            },
            {
              name: 'Themes',
              status: false,
              redirectingUrl: '/admin/website/themes',
              show: this.staffService.getStaffPermission('WEBSITE'),
            },
            {
              name: 'FAQ',
              status: false,
              redirectingUrl: '/admin/website/faq',
              show: this.staffService.getStaffPermission('FAQ'),
            },
            {
              name: 'Blogs',
              status: false,
              thirdPanelData: [
                {
                  name: 'Blogs',
                  status: true,
                  redirectingUrl: '/admin/website/blogs/listing',
                },
                {
                  name: 'Authors',
                  status: false,
                  redirectingUrl: '/admin/website/blogs/authors/listing',
                },
                {
                  name: 'Tags',
                  status: false,
                  redirectingUrl: '/admin/website/blogs/tags/listing',
                },
              ],
              show: this.staffService.getStaffPermission('BLOGS'),
            },
            {
              name: 'SEO',
              status: false,
              redirectingUrl: '/admin/website/seo',
              show: this.staffService.getStaffPermission('SEO'),
            },
            {
              name: 'Analytics',
              status: false,
              redirectingUrl: '/admin/website/analytics',
              show: this.staffService.getStaffPermission('WEBSITE_ANALYTICS'),
            },
            {
              name: 'Settings',
              status: false,
              redirectingUrl: '/admin/website/settings',
              show: this.staffService.getStaffPermission('WEBSITE'),
            },
            {
              name: 'Payment Integration',
              status: false,
              redirectingUrl: 'admin/website/cf-onboarding',
              show: this.staffService.getStaffPermission('WEBSITE'),
            },
            {
              name: 'FAQ',
              status: false,
              redirectingUrl: '/admin/website/faq',
              show: this.staffService.getStaffPermission('FAQ'),
            },
          ],
        },
        {
          name: 'Invoice',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          subArray: [
            {
              name: 'Invoices',
              status: true,
              redirectingUrl: '/admin/invoice/v2-list-invoice/invoice',
            },
            {
              name: 'Credit Notes',
              status: true,
              redirectingUrl: '/admin/invoice/v2-list-invoice/creditnotes',
            },
            {
              name: 'Purchases',
              status: true,
              redirectingUrl: '/admin/invoice/v2-list-invoice/purchase',
            },
            {
              name: 'Purchase Orders',
              status: true,
              redirectingUrl: '/admin/invoice/v2-list-invoice/purchaseorder',
            },
            {
              name: 'Debit Notes',
              status: true,
              redirectingUrl: '/admin/invoice/v2-list-invoice/debitnote',
            },
            {
              name: 'Quotations',
              status: true,
              redirectingUrl: '/admin/invoice/v2-list-invoice/quotation',
            },
            {
              name: 'Delivery Challans',
              status: true,
              redirectingUrl: '/admin/invoice/v2-list-invoice/deliverychallan',
            },
            {
              name: 'Expenses',
              status: true,
              redirectingUrl: '/admin/invoice/list-indirect-income/expense',
            },
            {
              name: 'Indirect Income',
              status: true,
              redirectingUrl:
                '/admin/invoice/list-indirect-income/indirectincome',
            },
            {
              name: 'Customers',
              status: true,
              redirectingUrl: '/admin/invoice/customer',
            },
            {
              name: 'Vendors',
              status: true,
              redirectingUrl: '/admin/invoice/vendor',
            },
          ],
          show: this.staffService.getStaffPermission('INVOICE'),
        },
        // {
        //   name: 'Customers',
        //   imgUrl: '',
        //   status: false,
        //   arrowRotate: false,
        //   redirectingUrl: '/admin/ecommerce/list-customer',
        //   subArray: [
        //     {
        //       name: 'Customer-list',
        //       status: true,
        //       redirectingUrl: '/admin/ecommerce/list-customer'
        //     },
        //     {
        //       name: 'Reviews and Ratings',
        //       status: false,
        //       redirectingUrl: '/admin/ecommerce/ratings-reviews'
        //     }
        //   ],
        // },
        {
          name: 'CRM',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          subArray: [
            {
              name: 'Dashboard',
              status: true,
              redirectingUrl: '/admin/crm/dashboard',
            },
            {
              name: 'Sales Dashboard',
              status: true,
              redirectingUrl: '/admin/crm/telesales-dashboard',
            },
            {
              name: 'Leads',
              status: true,
              redirectingUrl: '/admin/crm/list-leads',
            },
            {
              name: 'Customers',
              status: true,
              redirectingUrl: '/admin/crm/list-customers',
            },
            {
              name: 'Tasks',
              status: true,
              redirectingUrl: '/admin/crm/list-tasks',
            },
            {
              name: 'Meetings',
              status: true,
              redirectingUrl: '/admin/crm/list-meetings',
            },
            {
              name: 'Calls',
              status: true,
              redirectingUrl: '/admin/crm/list-calls',
            },
            {
              name: 'My Enquiry',
              status: true,
              redirectingUrl: '/admin/crm/my-enquiry',
            },
            {
              name: 'Settings',
              status: false,
              redirectingUrl: 'admin/crm/crm-config/enquiry-form',
            },
          ],
          show: this.staffService.getStaffPermission('CRM'),
        },
        {
          name: 'Appointment',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/appointments/list-appointments',
          subArray: [
            {
              name: 'Appointments',
              status: true,
              redirectingUrl: '/admin/appointments/list-appointments',
            },
            {
              name: 'Manage',
              status: true,
              redirectingUrl: '/admin/appointments/manage-appointments',
            },
          ],
          show: this.staffService.getStaffPermission('APPOINTMENTS'),
        },
        {
          name: 'Staff',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/staff/list-staff',
          subArray: [],
          show: this.staffService.getStaffPermission('STAFF'),
        },
        {
          name: 'Marketing',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          subArray: [
            {
              name: 'Post Summary',
              status: true,
              redirectingUrl: '/admin/marketing/list-overview',
            },
            {
              name: 'Ideas',
              status: false,
              redirectingUrl: '/admin/marketing/list-ideas',
            },
            {
              name: 'Post',
              status: false,
              redirectingUrl: '/admin/marketing/list-posts',
            },
            {
              name: 'Calender',
              status: false,
              redirectingUrl: '/admin/marketing/calender',
            },
            {
              name: 'list-templates',
              status: false,
              redirectingUrl: '/admin/marketing/list-templates',
            },
            {
              name: 'Campaigns',
              status: false,
              redirectingUrl: '/admin/marketing/campaign-dashboard',
            },
          ],
        },
        {
          name: 'Product',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/products/list-products',
          subArray: [],
          show: this.staffService.getStaffPermission('PRODUCTS'),
        },
        // {
        //   name:'Apps',
        //   imgUrl:'',
        //   status:false,
        //   arrowRotate:false,
        //   redirectingUrl : 'admin/app-registry/list-apps',
        //   subArray:[],
        //   // show: this.staffService.getStaffPermission('PRODUCT')
        // },
      ];
    } else {
      this.sideNavData = [
        {
          name: 'Orders',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/ecommerce/list-orders',
          show:
            this.businessType === 'E_COMMERCE' &&
            this.staffService.getStaffPermission('ORDERS'),
          subArray: [],
        },
        {
          name: 'Dashboard',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/ecommerce/ecommerce-dashboard',
          show: true,
          subArray: [],
        },
        {
          name: 'Discounts',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/ecommerce/list-discounts',
          show: this.businessType === 'E_COMMERCE',
          subArray: [],
        },
        {
          name: 'Product',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/products/list-products',
          subArray: [],
          show: this.staffService.getStaffPermission('PRODUCTS'),
        },
        {
          name: 'Customers',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/ecommerce/list-customer',
          show:
            this.businessType === 'E_COMMERCE' &&
            this.staffService.getStaffPermission('CUSTOMER'),
          subArray: [],
        },
        {
          name: 'Online Store',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          show:
            this.staffService.getStaffPermission('WEBSITE') ||
            this.staffService.getStaffPermission('BLOGS') ||
            this.staffService.getStaffPermission('SEO') ||
            this.staffService.getStaffPermission('WEBSITE_ANALYTICS'),
          subArray: [
            {
              name: 'Preview',
              status: true,
              redirectingUrl: '/admin/website/preview',
              show: this.staffService.getStaffPermission('WEBSITE'),
            },
            {
              name: 'Themes',
              status: false,
              redirectingUrl: '/admin/website/themes',
              show: this.staffService.getStaffPermission('WEBSITE'),
            },
            {
              name: 'Blogs',
              status: false,
              thirdPanelData: [
                {
                  name: 'Blogs',
                  status: true,
                  redirectingUrl: '/admin/website/blogs/listing',
                },
                {
                  name: 'Authors',
                  status: false,
                  redirectingUrl: '/admin/website/blogs/authors/listing',
                },
                {
                  name: 'Tags',
                  status: false,
                  redirectingUrl: '/admin/website/blogs/tags/listing',
                },
              ],
              show: this.staffService.getStaffPermission('BLOGS'),
            },
            {
              name: 'SEO',
              status: false,
              redirectingUrl: '/admin/website/seo',
              show: this.staffService.getStaffPermission('SEO'),
            },
            {
              name: 'Analytics',
              status: false,
              redirectingUrl: '/admin/website/analytics',
              show: this.staffService.getStaffPermission('WEBSITE_ANALYTICS'),
            },
            {
              name: 'Settings',
              status: false,
              redirectingUrl: '/admin/website/settings',
              show: this.staffService.getStaffPermission('WEBSITE'),
            },
          ],
        },
        {
          name: 'CRM',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          subArray: [
            {
              name: 'Dashboard',
              status: true,
              redirectingUrl: '/admin/crm/dashboard',
            },
            {
              name: 'Leads',
              status: true,
              redirectingUrl: '/admin/crm/list-leads',
            },
            {
              name: 'Customers',
              status: true,
              redirectingUrl: '/admin/crm/list-customers',
            },
            {
              name: 'Tasks',
              status: true,
              redirectingUrl: '/admin/crm/list-tasks',
            },
            {
              name: 'Meetings',
              status: true,
              redirectingUrl: '/admin/crm/list-meetings',
            },
            {
              name: 'Calls',
              status: true,
              redirectingUrl: '/admin/crm/list-calls',
            },
            {
              name: 'My Enquiry',
              status: true,
              redirectingUrl: '/admin/crm/my-enquiry',
            },
            {
              name: 'Settings',
              status: false,
              redirectingUrl: 'admin/crm/crm-config/enquiry-form',
            },
          ],
          show: this.staffService.getStaffPermission('CRM'),
        },
        {
          name: 'Appointment',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/appointments/list-appointments',
          subArray: [
            {
              name: 'Appointments',
              status: true,
              redirectingUrl: '/admin/appointments/list-appointments',
            },
            {
              name: 'Manage',
              status: true,
              redirectingUrl: '/admin/appointments/manage-appointments',
            },
          ],
          show: this.staffService.getStaffPermission('APPOINTMENTS'),
        },
        {
          name: 'Staff',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          redirectingUrl: '/admin/staff/list-staff',
          subArray: [],
          show: this.staffService.getStaffPermission('STAFF'),
        },
        {
          name: 'Marketing',
          imgUrl: '',
          status: false,
          arrowRotate: false,
          subArray: [
            {
              name: 'Post Summary',
              status: true,
              redirectingUrl: '/admin/marketing/list-overview',
            },
            {
              name: 'Ideas',
              status: false,
              redirectingUrl: '/admin/marketing/list-ideas',
            },
            {
              name: 'Post',
              status: false,
              redirectingUrl: '/admin/marketing/list-posts',
            },
            {
              name: 'Calender',
              status: false,
              redirectingUrl: '/admin/marketing/calender',
            },
            {
              name: 'list-templates',
              status: false,
              redirectingUrl: '/admin/marketing/list-templates',
            },
          ],
        },
      ];
    }
  }
  displayName: any = {
    Sales: 'Sales',
    Purchases: 'Purchases',
    Quotations: 'Quotations',
    Expenses: 'Expenses',
    Website: 'Website',
    CRM: 'CRM',
    Appointment: 'Appointment',
    SMM: 'Social Flow',
    Prism: 'Prism',
    User: 'User',
    'AI Writer': 'AI Writer',
    Apps: 'Apps',
    Products: 'Products',
    Customers: 'Customers',
    Vendors: 'Vendors',
    'Billing Customers': 'Billing Customers',
    Orders: 'Orders',
    Discounts: 'Discounts',
    Dashboard: 'Dashboard',
    Home: 'Home',
    Planboard: 'Planboard',
    'Store Listing': 'Store Listing',
    'People Manager': 'People Manager',
    PassBook: 'Passbook',
    Helpdesk: 'Helpdesk',
    Newsletter: 'Newsletter',
    'AI Composer': 'AI Composer',
    'Project Lens': 'Project Lens',
    Horizyn: 'Horizyn',
    Workflows: 'Workflows',
    Recommendations: 'Recommendations'
  };
  reFiltersideNavDataDynamically(data: any[]): void {
    if (this.businessType === 'STATIC' && !this.removeHome) {
      this.sideNavData.push({
        appName: 'Home',
        redirectUrl: '/admin/home',
        show: true,
        favorite: true
      });
    }
    // if(this.businessType === 'E_COMMERCE'){
    // }
    this.sideNavData = [...this.sideNavData, ...data, ...this.defaultApps];
    let index = 0;
    for (let ele of this.sideNavData) {
      ele['displayName'] = this.displayName[ele.appName] || ele.appName;
      if (ele.appName == 'People Manager') {
        ele.redirectUrl = '/admin/hrms/home';
      }
      if (ele.appName == 'Planboard') {
        ele.redirectUrl = '/admin/work-management/home';
      }
      if (ele.appName == 'PassBook') {
        ele.redirectUrl = '/admin/passbook/overview'
        // const redirectUrl = this.iframService.getFirstAllowedTabUrl();

        // if (redirectUrl) {
        //   ele.redirectUrl = redirectUrl;
        // } else {
        //   // If no permission at all → hide PassBook completely
        //   ele.show = false;
        // }
      }
      if (ele.appName.split(' ').join('_') == 'Refer_and_Earn') {
        ele.redirectUrl = '/admin/referral/referral-programs'
      }
      if (ele.appName.split(' ').join('_') == 'Forms') {
        ele.redirectUrl = '/admin/forms/form-listing'
      }
      if (ele.appName == 'Workflows') {
        ele.redirectUrl = '/admin/workflows/home'
      }
      if (ele.appName == 'Recommendations') {
        ele.redirectUrl = '/admin/recommendations'
      }
      if (ele.appName === 'Social Flow') {
        const homeEntry = {
          appId: null,
          displayName: 'Home',
          displayOrder: 0,
          redirectionUrl: '/admin/marketing/dashboard',
          show: true,
          status: false,
          subAppId: '3fa85f64-5717-4562-b4fc-3c957f67afa6',
          subAppName: 'Home',
        };

        const settingsEntry = {
          appId: null,
          displayName: 'Settings',
          displayOrder: 1,
          redirectionUrl: '/admin/marketing/smm-settings',
          show: true,
          status: false,
          subAppId: '3fa85f64-5717-4562-b4fc-3c957f67afa6',
          subAppName: 'Settings',
        };
        if (!ele.subAppName) {
          ele.subAppName = [];
        }
        ele.subAppName.unshift(homeEntry);
        ele.subAppName.push(settingsEntry);
      }
      if (ele.appName?.toString().toLowerCase().replace(/\s/g, '') === 'helpdesk') {
        ele.redirectUrl = '/admin/helpdesk/helpdesk-dashboard';
        ele.subAppName = [
          {
            subAppName: 'DASHBOARD',
            displayName: 'Dashboard',
            redirectionUrl: '/admin/helpdesk/helpdesk-dashboard',
            show: true
          },
          {
            subAppName: 'TICKET',
            displayName: 'Tickets',
            redirectionUrl: '/admin/helpdesk/helpdesk-global-tickets',
            show: true
          },
          {
            subAppName: 'STAFF_TICKET',
            displayName: 'Staff Tickets',
            redirectionUrl: '/admin/helpdesk/helpdesk-staff-tickets',
            show: true
          },
          {
            subAppName: 'MY_TICKET',
            displayName: 'My Tickets',
            redirectionUrl: '/admin/helpdesk/helpdesk-my-tickets',
            show: true
          },
          {
            subAppName: 'CUSTOMER_RATING',
            displayName: 'Customer Ratings',
            redirectionUrl: '/admin/helpdesk/helpdesk-customer-ratings',
            show: true
          },
          {
            subAppName: 'SETTING',
            displayName: 'Settings',
            redirectionUrl: '/admin/helpdesk/helpdesk-settings',
            show: true
          }
        ];
      }
      index++;
    }

    // let materialBasedConfiguration: boolean = localStorage.getItem('isMaterialBasedPricing') === 'true';

    // if (materialBasedConfiguration) {
    //   this.sideNavData.push({
    //     appName: 'Materials',
    //     redirectUrl: '/admin/metal-price',
    //     show: true,
    //     status: false,
    //   }, {
    //     appName: 'Material Type',
    //     redirectUrl: '/admin/metal-type',
    //     show: true,
    //     status: false,
    //   });
    // }

    setTimeout(() => {
      this.sideNavData.forEach((element) => {
        if (element.appName == 'CRM') {
          //
          this._eventService.crmInstalled.emit({ installed: true });
        }
      });
    }, 500);

    this.groupSideNavData()
    this.checkCurrentPanel();
  }

  groupSideNavData() {
    this.groupedSideNav = []; this.pinnedApps = [];
    this.pinnedApps = this.sideNavData.filter(app => app.favorite);
    const categoryMap = new Map<string, any[]>();

    this.sideNavData.filter(app => !app.favorite).forEach(app => {
      const category = app.appCategory?.name || 'Default Apps';
      if (!categoryMap.has(category)) {
        categoryMap.set(category, []);
      }
      categoryMap.get(category)?.push(app);
    });

    categoryMap.forEach((apps, category) => {
      this.groupedSideNav.push({ category, apps });
    });
  }

  hasVisibleApp(apps: any[]): boolean {
    return apps ? apps.some(app => !app.hasOwnProperty('show') || app.show) : false;
  }

  markAppPinned(item: any) {
    let isFav
    if (item.favorite === true) {
      isFav = false
    }
    else {
      isFav = true
    }
    this.isLoading = true;
    this.navMenuService.markAppPinned(item.appId, isFav).subscribe({
      next: (res: any) => {
        if (item.favorite === true) {
          this._snackBar.open('App unpinned from side bar', 'Close', {
            duration: 1500
          })
        }
        else {
          this._snackBar.open('App pinned to side bar', 'Close', {
            duration: 1500
          })
        }
        this.loadNavData()
      },
      error: (err) => {
        this._snackBar.open('Failed to update app status', 'Close', {
          duration: 1500
        })
      }
    })
  }

  // checkCurrentPanel() {
  //   const currentUrl = this.router.url.split("?")[0];
  //   this.getDetails.emit({ checkCRM: true });

  //   this.activeSubApp = null;
  //   let fallbackActiveApp:any = null;

  //   for (let data of this.sideNavData) {
  //     if (data.appName === 'Home') {
  //       data.status = data.redirectUrl && currentUrl.startsWith(data.redirectUrl);
  //       continue;
  //     }

  //     data.status = false;
  //     data['show'] = this.isStaffAdmin
  //       ? true
  //       : this.showSidePanel[data.appName.toUpperCase()]?.['show'];

  //     let matchedSubApp = false;

  //     if (Array.isArray(data.subAppName)) {
  //       for (let element of data.subAppName as any[]) {
  //         const subAppName = element.displayName || element.subAppName;

  //         element['show'] = this.isStaffAdmin
  //           ? true
  //           : this.showSidePanel[data.appName.toUpperCase()]?.[subAppName?.toUpperCase()];

  //         if (element.redirectionUrl && currentUrl.startsWith(element.redirectionUrl)) {
  //           data.status = true;
  //           element.status = true;
  //           this.activeSubApp = data;
  //           matchedSubApp = true;
  //         } else {
  //           element.status = false;
  //         }
  //       }
  //     }

  //     if (!matchedSubApp && data.redirectUrl && currentUrl.startsWith(data.redirectUrl)) {
  //       data.status = true;
  //       this.activeSubApp = data;
  //     }

  //     // Fallback: if no subApp matched but URL matches base path
  //     if (!matchedSubApp && !this.activeSubApp &&
  //         currentUrl.startsWith(`/admin/${data.appName.toLowerCase().replace(/\s+/g, '-')}`)) {
  //       fallbackActiveApp = data;
  //     }
  //   }

  //   if (!this.activeSubApp && fallbackActiveApp) {
  //     this.activeSubApp = fallbackActiveApp;
  //     fallbackActiveApp.status = true;
  //   }
  // }

  checkCurrentPanel() {
    const currentUrl = this.router.url.split('?')[0];
    const queryParams = new URLSearchParams(
      this.router.url.split('?')[1] || '',
    );
    const projectIdFromUrl = queryParams.get('projectId');

    if (projectIdFromUrl) {
      this.selectedProjectId = projectIdFromUrl;
    }

    this.getDetails.emit({ checkCRM: true });

    // Always read fresh from localStorage — avoids stale values from earlier loadNavData calls
    const isAdmin = this.staffService.isStaffAdmin();
    const sidePanel = this.staffService.showSidePanel();

    this.activeSubApp = null;
    let fallbackActiveApp: any = null;

    for (let data of this.sideNavData) {
      if (data.appName === 'Home') {
        data.status =
          data.redirectUrl &&
          new RegExp(`^${data.redirectUrl}(\/|$)`).test(currentUrl);
        continue;
      }

      data.status = false;

      if (data.appName == 'User') {
        data.appName = 'Staff';
      }

      // admin → show all; non-admin → check permission by app code
      data['show'] = isAdmin
        ? true
        : (sidePanel[data.code]?.['show'] ?? sidePanel[data.appName?.toUpperCase()]?.['show'] ?? false);

      if (data.appName == 'Staff') {
        data.appName = 'User';
      }

      let matchedSubApp = false;
      if (Array.isArray(data.subAppName)) {
        for (let element of data.subAppName as any[]) {
          const subAppName = element.subAppName || element.displayName;

          element['show'] = isAdmin
            ? true
            : (sidePanel[data.code]?.[element.code]
              ?? sidePanel[data.code]?.[subAppName?.toUpperCase()]
              ?? sidePanel[data.appName?.toUpperCase()]?.[subAppName?.toUpperCase()]
              ?? false);

          if (element.redirectionUrl) {
            const regex = new RegExp(`^${element.redirectionUrl}(\\/|\\?|$)`);
            if (regex.test(currentUrl)) {
              data.status = true;
              element.status = true;
              this.activeSubApp = data;
              matchedSubApp = true;
            } else if (
              (currentUrl.startsWith('/admin/work-management/work-item') ||
                currentUrl.startsWith('/admin/work-management/settings-pms')) &&
              subAppName?.toLowerCase() === 'projects'
            ) {
              data.status = true;
              element.status = true;
              this.activeSubApp = data;
              matchedSubApp = true;
            } else if (
              currentUrl.startsWith('/admin/products/') &&
              element.redirectionUrl === '/admin/products/list-products'
            ) {
              data.status = true;
              element.status = true;
              this.activeSubApp = data;
              matchedSubApp = true;
            } else {
              element.status = false;
            }
          }
        }
      }

      if (
        !matchedSubApp &&
        data.redirectUrl &&
        new RegExp(`^${data.redirectUrl}(\/|$)`).test(currentUrl)
      ) {
        data.status = true;
        this.activeSubApp = data;
      }

      if (
        !matchedSubApp &&
        !this.activeSubApp &&
        data.appName &&
        new RegExp(
          `^/admin/${data.appName.toLowerCase().replace(/\s+/g, '-')}(\/|$)`,
        ).test(currentUrl)
      ) {
        fallbackActiveApp = data;
      }
    }

    if (!this.activeSubApp && fallbackActiveApp) {
      this.activeSubApp = fallbackActiveApp;
      fallbackActiveApp.status = true;
    }

    // ✅ Emit only if subPanel (with subAppName array) exists and is non-empty
    const isSubPanelOpen =
      !!this.activeSubApp &&
      Array.isArray(this.activeSubApp.subAppName) &&
      this.activeSubApp.subAppName.length > 0;

    this.subPanelOpened.emit(isSubPanelOpen);
  }

  defaultApps: any = [
    // {
    //   appName: 'User',
    //   redirectUrl: '/admin/staff/list-staff',
    //   show: this.staffService.getStaffPermission('STAFF', 'VIEW', 'STAFF'),
    // },
    // {
    //   appName: 'Coupons',
    //   redirectUrl: '/admin/vouchers/crm-vouchers',
    //   show: true,
    //   subAppName: [
        // {
        //   subAppName: 'Crm Vouchers',
        //   displayName: 'Crm Vouchers',
        //   redirectionUrl: '/admin/vouchers/crm-vouchers',
        //   show: true,
        // },
    // {
    //   appName: 'Forms',
    //   redirectUrl: '/admin/form/list-forms',
    //   show: true,
    // },
    // {
    //   appName: 'Referral',
    //   redirectUrl: '/admin/referral/dashboard',
    //   // show: this.staffService.getStaffPermission('STAFF', 'VIEW', 'STAFF'),
    // },
    // {
    //   appName: 'Dialer',
    //   redirectUrl: '/admin/dialer/dashboard',
    //   show: true,
    // },
    // {
    //   appName: 'Forms',
    //   redirectUrl: '/admin/forms/form-listing',
    //   show: true,
    // },
    // {
    //   appName: "Campaigns",
    //   redirectUrl: "/admin/campaigns/campaign-list",
    //   show: true
    // },
    // {
    //   appName: 'Campaigns Dashboard',
    //   redirectUrl: '/admin/crm/campaigns/dashboard',
    //   show: true,
    // }
    // {
    //   appName: 'Customers',
    //   redirectUrl: '/admin/customer',
    //   show: true,
    // }
    // {
    //   appName: 'Ads Manager',
    //   redirectUrl: '/admin/ads/meta-ads-analytics',
    //   show: true,
    //   subAppName : [
    //     {
    //       subAppName : 'Meta Ads',
    //       displayName : 'Meta Ads',
    //       redirectionUrl : '/admin/ads/meta-ads-analytics',
    //       show : true,
    //     },
    //     {
    //       subAppName : 'Google Ads',
    //       displayName : 'Google Ads',
    //       redirectionUrl : '/admin/ads/google-ads-analytics',
    //       show : true,
    //     },
    //   ]
    // },
    // {
    //   appName: 'Inbox',
    //   redirectUrl: '/admin/inbox/all-messages',
    //   show: true,
    //   subAppName: [
    //     {
    //       subAppName: 'All Messages',
    //       displayName: 'All Messages',
    //       redirectionUrl: '/admin/inbox/all-messages',
    //       show: true,
    //     },
    //     {
    //       subAppName: 'Settings',
    //       displayName: 'Settings',
    //       redirectionUrl: '/admin/inbox/inbox-settings/channels',
    //       show: true,
    //     },
    //   ],
    // },
  ];

  settings: any;
  fromHome() {
    this.settings = this._eventService.goTosettings.subscribe((res: any) => {
      if (res.setting) {
        setTimeout(() => {
          this.checkCurrentPanel();
        }, 500);
      }
    });
  }
  blogs: any;
  forBlogs() {
    this.blogs = this._eventService.goToblogs.subscribe((res: any) => {
      if (res.blog || res.view) {
        //
        setTimeout(() => {
          this.checkCurrentPanel();
        }, 500);
      }
    });
  }

  leads: any;
  forLeads() {
    this.leads = this._eventService.goToLeads.subscribe((res: any) => {
      if (res.lead || res.view) {
        setTimeout(() => {
          this.checkCurrentPanel();
        }, 500);
      }
    });
  }
  invoices: any;
  forInvocies() {
    this.invoices = this._eventService.goToInvoices.subscribe((res: any) => {
      if (res.invoice || res.view) {
        setTimeout(() => {
          this.checkCurrentPanel();
        }, 500);
      }
    });
  }

  checkforCurrentUrl() {
    let currentUrl = this.router.url.split('/');
    //
    let redirectingUrl = this.router.url.split('//')[0];
    //

    //
    this.sideNavData.forEach((data) => {
      if (currentUrl.includes(data.name.toLowerCase())) {
        data.status = true;
        if (data.subArray.length > 0) {
          data.subArray.forEach((element) => {
            if (element.redirectingUrl) {
              if (element.redirectingUrl === redirectingUrl) {
                element.status = true;
              } else {
                element.status = false;
              }
            } else {
              // if(redirectingUrl){
              // }
              // else{
              if (element.thirdPanelData) {
                element.thirdPanelData.forEach((thirdPanel) => {
                  if (thirdPanel.redirectingUrl === redirectingUrl) {
                    thirdPanel.status = true;
                    element.status = true;
                    this.openThirdPanel.emit({
                      value: true,
                      data: element.thirdPanelData,
                    });
                  } else {
                    thirdPanel.status = false;
                    // element.status = true
                    // this.openThirdPanel.emit({ value: true, data: element.thirdPanelData });
                  }
                });
              }
              // }
            }
          });
        }
      } else {
        data.status = false;
      }
    });
  }
  // openNav() {}

  subPanel(ev: any) {
    //
    this.sideNavData.forEach((snd) => {
      if (ev.name === snd.name) {
        snd.status = true;
        if (ev.subArray.length != 0) {
          this.openSecondPanel.emit({ value: true, data: ev });
          this.router.navigate([`${snd.subArray[0].redirectingUrl}`]);
        }
      } else {
        snd.status = false;
      }
    });
  }
  expandPanel(ev: any) {
    this.sideNavData.forEach((snd) => {
      if (ev.appName.toLowerCase() === snd.appName.toLowerCase()) {
        snd.status = true;
        if ((snd.subAppName?.length || 0) > 0) {
          snd.subAppName.forEach((aa, i) => {
            snd.subArray[i].status = false;
          });

          for (let i = 0; i < snd.subAppName?.length || 0; i++) {
            let aa = snd.subAppName[i];
            if (i === 0 && (!aa.hasOwnProperty('show') || aa.show)) {
              this.router.navigate([`${snd.subAppName[0].redirectionUrl}`]);
              snd.subAppName[i].status = true;
              break;
            } else if (aa.show) {
              if (aa.thirdPanelData && aa.thirdPanelData.length > 0) {
                this.router.navigate([
                  `${aa.thirdPanelData[0].redirectingUrl}`,
                ]);
              } else
                this.router.navigate([`${snd.subArray[i].redirectingUrl}`]);
              snd.subArray[i].status = true;
              break;
            }
          }
          this.openThirdPanel.emit({ value: false, data: [] });
        } else {
          this.router.navigate([`${snd.redirectingUrl}`]);
          this.openThirdPanel.emit({ value: false, data: [] });
        }
      } else {
        snd.status = false;
      }
    });
    this.checkPassbookInstall();
  }

  expandPanelV2(selectedPanel: any): void {
    let redirectionUrl: string = '';

    this.sideNavData.forEach((panel) => {
      // Collapse all panels
      panel.status = false;
      panel.lastSeen = false;

      // Reset all subpanels
      // if (panel.subAppName?.length) {
      //   panel.subAppName.forEach(sub => {
      //      sub.status = false;
      //      sub.lastSeen = false;
      //   });
      // }

      // Activate selected panel
      // if(panel.appName == 'PassBook'){
      //   redirectionUrl = this.iframService.getFirstAllowedTabUrl() || '';
      // }
      if (panel.appName === selectedPanel.appName) {
        panel.status = true;

        if (panel.subAppName?.length > 0) {
          const allFalse = panel.subAppName.every(
            (item: any) => !item.lastSeen,
          );

          if (allFalse) {
            panel.subAppName[0].status = true;
            redirectionUrl = panel.subAppName[0].redirectionUrl;
          } else {
            const activePanel = panel.subAppName.find(
              (item: any) => item.lastSeen,
            );
            redirectionUrl = activePanel?.redirectionUrl;
          }
          // panel.subAppName[0].status = true;
          // redirectionUrl = panel.subAppName[0].redirectionUrl;
        } else {
          redirectionUrl = panel.redirectUrl;
        }

        this.activeSubApp = panel; // Optional: If you're tracking active state elsewhere
        if (this.activeSubApp?.appName === 'Social Flow') {
          if (!this.activeSubApp.subAppName) {
            this.activeSubApp.subAppName = [];
          }
          const alreadyExists = this.activeSubApp.subAppName.some(
            (s: any) => s.subAppName === 'Home' || s.displayName === 'Home'
          );
          if (!alreadyExists) {
            this.activeSubApp.subAppName.unshift({
              appId: null,
              displayName: 'Home',
              displayOrder: 0,
              redirectionUrl: '/admin/marketing/dashboard',
              show: true,
              status: true,
              subAppId: '3fa85f64-5717-4562-b4fc-3c957f67afa6',
              subAppName: 'Home',
            });
            this.activeSubApp.subAppName.push({
              appId: null,
              displayName: 'Settings',
              displayOrder: 1,
              redirectionUrl: '/admin/marketing/smm-settings',
              show: true,
              status: false,
              subAppId: '3fa85f64-5717-4562-b4fc-3c957f67afa6',
              subAppName: 'Settings',
            })
          }
        }
      }
    });

    if (redirectionUrl) {
      this.router.navigate([redirectionUrl]);
    }
  }

  subDataClick(name: any, ev: any) {
    this.sideNavData.forEach((snd) => {
      if (snd?.name?.toLowerCase() === name?.toLowerCase()) {
        snd.subArray.forEach((element) => {
          if (element.name.toLowerCase() === ev.name.toLowerCase()) {
            element.status = true;
            if (element.thirdPanelData) {
              this.router.navigate([
                `${element.thirdPanelData[0].redirectingUrl}`,
              ]);
              this.openThirdPanel.emit({
                value: true,
                data: element.thirdPanelData,
              });
              element.thirdPanelData[0].status = true;
            } else {
              this.router.navigate([`${element.redirectingUrl}`]);
              this.openThirdPanel.emit({ value: false, data: [] });
            }
          } else {
            element.status = false;
          }
        });
      }
    });
  }

  changeSubPanel(seletedPanel: any, selectedSubPanel: any) {
    let redirectionUrl = '';

    for (let panel of this.sideNavData) {
      if (panel.appName === seletedPanel.appName) {
        for (let subPanel of panel?.subAppName || []) {
          if (panel.subAppName === "AI Composer") {
            this._eventService.aiWriterCalled.next({ data: { toOpen: 'post', type: 'new-post' } })
            setTimeout(() => {
              let dialog = this.websiteMarketingService.openPost(
                AiWriterWrapperComponent,
                'calc(100vh)',
                '100vw',
                '100vw',
                {},
                'ai-writer-popup'
              );
              dialog.afterClosed().subscribe((data: any) => {
              });
            }, 1200);
            return
          }
          subPanel['status'] = false;
          subPanel['lastSeen'] = false;
          if (subPanel.subAppName === selectedSubPanel.subAppName) {
            subPanel['status'] = true;
            subPanel['lastSeen'] = true;
            redirectionUrl = subPanel.redirectionUrl;
          }
        }
      }
    }

    try {
      const offcanvasEl = document.getElementById('moreMenuOffcanvas');
      if (offcanvasEl) {
        const bsOffcanvas = new bootstrap.Offcanvas(offcanvasEl);
        bsOffcanvas.hide();
      }
    } catch (e) { }
    this.selectedProjectId = null;
    this.router.navigate([redirectionUrl]);
  }

  openScreenInResponsiveness(data) {
    // this.router.navigate([`${data.redirectingUrl}`]);
    if (data.thirdPanelData) {
      this.router.navigate([`${data.thirdPanelData[0].redirectingUrl}`]);
    } else {
      this.router.navigate([`${data.redirectingUrl}`]);
    }
    this.openThirdPanel.emit({
      value: data.thirdPanelData?.length > 0,
      data: data.thirdPanelData,
    });
    this.closeSideBar();
    //
  }
  collapsing() {
    this.collapseSideNav = !this.collapseSideNav;
    this.collapsingMainNav.emit({ collapse: this.collapseSideNav });
  }

  arrowBack(value: number) {
    this.sideNavData.forEach((element: any, index: any) => {
      if (value === index) {
        //
        element.arrowRotate = !element.arrowRotate;
        this.router.navigate([`${element.subArray[0].redirectingUrl}`]);
      } else {
        element.arrowRotate = false;
      }
    });
  }

  @Output('closeNav') closeNav = new EventEmitter<void>();

  closeSideBar() {
    this.closeNav.emit();
  }

  switchBusiness(item: any) {
    // When changing from one business to another, swap the auth session first
    // (new access token); on a fresh entry this does nothing.
    this._authService.ensureBusinessSession(item.id).subscribe({
      next: () => this.applyBusinessSwitch(item),
      error: (err: any) => {
        this._snackBar.open(
          err?.error?.message || 'Unable to switch business. Please try again.',
          'Close',
          { duration: 2000 },
        );
      },
    });
  }

  private applyBusinessSwitch(item: any) {
    let staffId = localStorage.getItem(StorageKeys.STAFF_ID);
    this.allBusiness.forEach((element) => {
      if (element.id === item.id) {
        element.status === true;
        //
        this._businessService
          .getDetailsByBusinessId(item.id, staffId)
          .subscribe(
            (res: any) => {
              window.localStorage.setItem(
                'bDetails',
                JSON.stringify(res.data.business),
              );
              localStorage.setItem(
                StorageKeys.BUSINESS_NAME,
                res.data.business.name,
              );
              this.staffService.setPermissionsFromBusinessList(res.data.business.id);
              this.businessType = res.data.business.type;
              this.loadNavData();
              window.localStorage.setItem('status', res.data.website.status);
              this._dbStorage.setBusinessId(res.data.business.id);
              this.subscriptionService.changeCurrentPlanDetails();
              this.getCurrencySymbol(res.data.business.id);
              this.socialLogin.logout();
              // Refresh the shell + any listening screens once, then go home. No page reload = no white flash.
              this._eventService.switchBusiness.emit({ switchBusiness: true });
              this.router.navigate(['/admin/home']);
            },
            (err) => {
              //
              // this.loader = false;
              this._snackBar.open(`${err.error.message}`, 'Close', {
                duration: 1500,
              });
            },
          );
      } else {
        element.status = false;
      }
    });
  }

  getCurrencySymbol(bId: any) {
    this._businessService.getCurrencySymbol(bId).subscribe({
      next: (value: any) => {
        //

        this._dbStorage.setBusinessPrefernce(JSON.stringify(value.data));
      },
      error: (err: any) => { },
    });
  }

  goToListing() {
    this.router.navigate(['/list-business']);
  }

  createNewBusiness() {
    if (this.screenWidth > 475) {
      this._businessService.openDialog(
        CreateNewBusinessComponent,
        'auto',
        '25%',
        { data: null },
        false,
      );
    }
    if (this.screenWidth < 475) {
      this._businessService.openDialog(
        CreateNewBusinessComponent,
        'auto',
        '100%',
        { data: null },
        false,
      );
    }
  }

  businessDetailss: any;
  businessDetails() {
    this.router.navigate([`/admin/account/business-details`]);
    setTimeout(() => {
      this.checkforCurrentUrl();
    }, 500);
  }

  registeredApps: any;
  getAppData() {
    let data = {
      page: 0,
      size: 1000000,
    };

    this.appRegistryService.getApps(data).subscribe({
      next: (res: any) => {
        this.registeredApps = res.data.data;
        const installedApps = this.registeredApps.filter((app: any) =>
          this.isAppInstalled(app.id),
        );
        this.sideNavData = [
          ...this.sideNavData,
          ...installedApps.map((app: any) => {
            return {
              name: app.name,
              imgUrl: app.logo,
              status: false,
              arrowRotate: false,
              redirectingUrl: '/admin/' + app.name?.replaceAll(' ', '-'),
              subArray: [],
              show: true,
            };
          }),
        ];
      },
    });
  }

  installedApps: string[] = [];

  getInstalledApps() {
    this.appRegistryService
      .getInstalledApps(this.businessId)
      .subscribe((res: any) => {
        this.installedApps = res.data?.appIds;
        this.getAppData();
      });
  }

  isAppInstalled(installAppId: string): boolean {
    return this.installedApps?.includes(installAppId);
  }

  sidePanelSubscription?: Subscription;

  updateSidePanel() {
    this.sidePanelSubscription = this._eventService.updateSidePanel.subscribe(
      (res: any) => {
        this.loadNavData();
      },
    );
    // Silent permission refresh — just re-check show/hide, no loader, no nav API call
    this._eventService.silentPermissionRefresh.subscribe(() => {
      this.checkCurrentPanel();
    });
  }

  // crm dashboard

  goToclicked: any;
  forclicked() {
    this.goToclicked = this._eventService.goToClikced.subscribe((res: any) => {
      if (res.view) {
        setTimeout(() => {
          this.checkCurrentPanel();
        }, 500);
      }
    });
  }

  pinnedWorkApps: string[] = [];

  isPinnedWorkApp(subPanel: any): boolean {
    return this.pinnedWorkApps.includes(subPanel.subAppName);
  }

  getVisibleSubApps(subApps: any[]): any[] {
    if (!subApps) return [];
    return subApps.slice(0, 3);
  }

  commonUse(subApps: any): any[] {
    if (!Array.isArray(subApps)) return [];
    const order = ['Home', 'Inbox', 'Your Work'];
    const byName = new Map(subApps.map((a: any) => [a?.subAppName, a]));
    return order.map((name) => byName.get(name)).filter(Boolean);
  }

  getRemainingSubApps(subApps: any[]): any[] {
    if (!subApps) return [];
    return subApps.slice(3);
  }

  openMoreMenu(item: any) {
    this.currentParentItem = item;
    this.currentMoreMenuItems = this.getRemainingSubApps(item.subAppName);
  }

  moreMenuOpen: boolean = false;

  toggleMoreMenu() {
    this.moreMenuOpen = !this.moreMenuOpen;
  }
  projectsOpen: boolean = true; // default is expanded

  toggleProjects() {
    this.projectsOpen = !this.projectsOpen;
  }

  projectList: any;
  favList: any;

  openProject(projectId: string): void {
    this.selectedProjectId = projectId;
    localStorage.setItem(StorageKeys.PROJECT_ID, projectId);
    this.router.navigate(['/admin/work-management/work-item'], {
      queryParams: { projectId },
    });
  }

  isCollapsed = false;
  isSubPanelCollapsed = false;
  activeSubApp: any = null;
  id: any;

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleSubPanel() {
    this.isSubPanelCollapsed = !this.isSubPanelCollapsed;
  }

  goToAddApps() {
    const currentUrl = this.router.url;
    this.appRegistryService.setReturnUrl(currentUrl);
    this.router.navigate(['/admin/app-registry/list-apps']);
  }

  showFavDropdown = true;
  //   getFavData(){
  //       let businessId = localStorage.getItem("businessId");
  //   this.projectService.getAllFav(businessId).subscribe(
  //     (res: any) => {
  //         this.favList = res.data || [];

  //     });
  // }
  cycleSelected: boolean = false;
  cycleData: any;
  projectWholeData: any;
  @Input() data: any;

  openFav(fav: any) {
    if (fav.type === 'CYCLE') {
      this.router.navigate(['/admin/work-management/work-item'], {
        queryParams: { tab: 'WORKITEM_TAB', data: fav, feature: 'CYCLE' },
      });
    } else if (fav.type === 'MODULE') {
      this.router.navigate(['/admin/work-management/work-item'], {
        queryParams: {
          type: 'MODULE',
          moduleId: fav.id,
          moduleName: fav.name,
          tab: 'MODULES_TAB',
          projectId: fav.projectId,
        },
      });
    }
    //  if (fav.type === 'CYCLE') {
    //   this.router.navigate(['/admin/work-management/cycles/cycle-workitems'], { queryParams: { type: 'CYCLE', cycleId: fav.id, projectId: fav.projectId, cycleName: fav.name } });
    //  }

    //  else if (fav.type === 'MODULE') {
    //   this.router.navigate(['/admin/work-management/modules/module-workitem'], { queryParams: { type: 'MODULE', moduleId: fav.id, projectId: fav.projectId, moduleName: fav.name } });
    //  }
    // if (fav.type === 'CYCLE') {
    //   this.favEvents.selectCycle(fav);
    //   this.router.navigate(['/admin/work-management/work-item'], { queryParams: { type : 'CYCLE' } }); // Navigate to cycles list
    //       setTimeout(() => {
    //     console.log('EMITTING FAV:', fav);   // ✅ check this
    //          this.favEvents.selectCycle(fav);
    //   }, 0);
    // }
  }

  showSubpanelTooltip = false;

  @ViewChild('subpaneltooltip') tooltipRef!: ElementRef;
  @ViewChild('iconsubpanelWrapper') iconWrapperRef!: ElementRef;

  toggleSubpanelTooltip() {
    this.showSubpanelTooltip = !this.showSubpanelTooltip;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInsideTooltip = this.tooltipRef?.nativeElement.contains(
      event.target,
    );
    const clickedInsideIcon = this.iconWrapperRef?.nativeElement.contains(
      event.target,
    );

    if (!clickedInsideTooltip && !clickedInsideIcon) {
      this.showSubpanelTooltip = false;
    }
  }

  isFeatureVisible(featureName: string): boolean {
    const bDetailsStr = localStorage.getItem('bDetails');
    if (!bDetailsStr) return true;

    const bDetails = JSON.parse(bDetailsStr);
    const featuresData = localStorage.getItem('crm_features_' + bDetails.id);
    if (!featuresData) return true;

    const features = JSON.parse(featuresData);
    const normalizedName = featureName.replace(/ /g, '').toLowerCase();

    const matchedFeature = features.find((f: any) => {
      const key = f.key.replace(/[-_ ]/g, '').toLowerCase();
      return (
        key === normalizedName ||
        new RegExp(`\\b${normalizedName}\\b`).test(key)
      );
    });

    // Show only if enabled (or not found in features)
    return matchedFeature ? matchedFeature.enabled : true;
  }

  navigateToBusinessCreation() {
    this.router.navigate(['/onboarding/industry-selection']);
  }
}
